<template>
 <v-card class="mx-5 my-5 d-flex flex-column" max-width="374">
    <!-- <v-card-title primary-title class="absolute top-0 trans-y-50">
      <div class="ellipsis-1 grey--text text--darken-3">
        {{ charity.title }}
      </div>
    </v-card-title> -->
    <!-- <figure class="w-full overflow-hidden h-full absolute top-0 left-0">
      <v-img class="blur" height="250" :src="$connection + sponsor.photoURL"></v-img>
    </figure> -->


    <figure class="h-48">
        <v-img contain class="w-full h-full" :src="$connection + sponsor.photoURL">
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0 grey lighten-2"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row> </template
        ></v-img>
      </figure>
    <!-- <figure class="w-full">
      <v-img
        class="w-full relative"
        cover
        height="280"
        :src="$connection + sponsor.photoURL"
      ></v-img>
    </figure> -->
    <v-card-text class="">
      <div>
        {{ sponsor.text }}
      </div>
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions >
       <div class="mt-5 text-center  w-full">
        <v-btn
        class="text-capitalize mx-auto text-center w-full"
        text 
        color="primary"
          @click="
            openInNewTab(sponsor.link)
          "
          >
          {{ $t('to_website') }}
          </v-btn
        >
        </div>
      <!-- <v-icon>mdi-chevron-right</v-icon>
      <a :href="charity.url" class="text-decoration-none" target="_blank">
        <v-btn class="text-capitalize" text color="primary">{{
          $t("help")
        }}</v-btn>
      </a> -->
    </v-card-actions>
  </v-card>
  <!-- <v-hover v-slot="{ hover }">
    <div
      class="w-full grow relative max-w-xs pa-10 d-flex flex-column align-center trans transparent mb-5"
      :class="hover ? 'transy bx-bottom' : ''"
    >
      <div class="relative w-full h-48 d-flex align-center justify-center">
        <div class="absolute">
          <v-avatar
          tile
            max-width="100"
            color="white"
            class="elevation-1 trans mx-auto relative"
            :class="hover ? 'mb-2 transy' : ''"
          >
            <v-img
              class="w-10-12  h-10-12 absolute"
              :src="$connection + sponsor.photoURL"
              :alt="sponsor.name"
              contain
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0 grey lighten-2"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row> </template
            ></v-img>
          </v-avatar>
        </div>
      </div>
      <div class="text-center mt-4 text-grey">
        {{ sponsor.text }}
      </div>
      <v-spacer></v-spacer>
      <div class="mt-5">
        <v-btn
        class="text-capitalize"
        text 
        color="primary"
          @click="
            openInNewTab(sponsor.link)
          "
          >
          {{ $t('to_website') }}
          </v-btn
        >
      </div>
    </div>
  </v-hover> -->
</template>

<script>
export default {
  props: ["sponsor", "index", "sponsor_length"],
  methods: {
    openInNewTab(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.trans {
  transition: all 0.3s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.8;
}
.on-hover {
  opacity: 1 !important;
}
.transy {
  transform: translateY(-20px);
}

.bx-bottom {
  box-shadow: 0 4px 2px -2px gray;
}
</style>